import { useTranslation } from 'react-i18next';

import { Button } from '../../../shared/ui/Button';
import styles from './TaskQuotaNotice.module.css';

interface TaskQuotaNoticeProps {
  taskLimit: number;
  onOpenBilling: () => void;
}

// PARA-131 (AC-15) — вместо общей ошибки формы: сколько задач разрешено на
// текущем тарифе и как перейти к прайсу. Значение приходит из тела 402, а не
// из констант фронта — лимит задаёт администратор (PARA-119).
export function TaskQuotaNotice({ taskLimit, onOpenBilling }: TaskQuotaNoticeProps): JSX.Element {
  const { t } = useTranslation('billing');

  return (
    <div className={styles.notice} data-testid="task-quota-notice">
      <p className={styles.text}>{t('quotaNotice.text', { limit: taskLimit })}</p>
      <Button variant="soft" fullWidth onClick={onOpenBilling}>
        {t('quotaNotice.cta')}
      </Button>
    </div>
  );
}
